import { http } from "./http";

export const statesApi = {
  list: (params) => http.get("/states", { params }).then((r) => r.data),
  getById: (id) => http.get(`/states/${id}`).then((r) => r.data),
  create: (payload) => http.post("/states", payload).then((r) => r.data),
  update: (id, payload) =>
    http.put(`/states/${id}`, payload).then((r) => r.data),
};
